import React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { ICalendarTaskItem } from "ui/Scripts/source/models/calendarTask/calendarTaskItem";
import { CalendarTaskState } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";

interface CalendarTaskCategoryColProps {
  item: ICalendarTaskItem;
}

export const CalendarTaskCategoryCol = (
    props: CalendarTaskCategoryColProps
) => {
    const color = props.item?.categoryColor ?? "#fff";
    const bordered = Base.isWhite(color);
    return (
        <div className="flex WithIcons jend">
            {!!props.item.isPrivate &&
                <span className="icon private" title={Translations.Private}></span>
            }
            <span
                className={"icon " + (props.item.state === CalendarTaskState.Finished
                    ? "listSuccess"
                    : props.item.state === CalendarTaskState.Started
                        ? "listStarted"
                        : "listNotStarted")}
                title={props.item.state === CalendarTaskState.Finished
                    ? Translations.CalendarTaskStateFinished
                    : props.item.state === CalendarTaskState.Started
                        ? Translations.CalendarTaskStateStarted
                        : Translations.CalendarTaskStateNotStarted
                }>
            </span>
            {!!props.item?.categoryCode &&
                <span
                    className={"stateText message state"}
                    style={{
                        backgroundColor: color,
                        color: Base.invertColor(color),
                        border: bordered ? "1px solid lightgray" : null,
                        lineHeight: bordered ? "16px" : null
                    }}
                >
                    {props.item?.categoryCode}
                </span>
            }
        </div>
    );
};
